import { c as _c } from "react/compiler-runtime";
import { ActionLink } from "@/components/common/actions/actions.component";
import { RichTextCondensed } from "@/components/common/rich-text/rich-text-condensed.component";
import { ImageWrapper } from "@/components/common/image/image.component";
import { getI18nString } from "@/lib/utils";
import type { BannerDataItem } from "./general-banner.types";
import { getLogo, getHeadline, getBodyCopy } from "./general-banner.utils";
export function BannerContent(t0) {
  const $ = _c(23);
  const {
    item
  } = t0;
  let t1;
  if ($[0] !== item) {
    t1 = getLogo(item);
    $[0] = item;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const logo = t1;
  let t2;
  if ($[2] !== item) {
    t2 = getHeadline(item);
    $[2] = item;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const headline = t2;
  let t3;
  if ($[4] !== item) {
    t3 = getBodyCopy(item);
    $[4] = item;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const bodyCopy = t3;
  let t4;
  if ($[6] !== logo) {
    t4 = logo && <div className="flex justify-center"><ImageWrapper visual={logo} className="h-[30px] w-auto tablet:h-10" imgClassName="object-contain" /></div>;
    $[6] = logo;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== headline) {
    t5 = headline && <h3 className="typography-mobile-heading-h4 tablet:typography-desktop-heading-h4 text-text-primary">{headline}</h3>;
    $[8] = headline;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== bodyCopy) {
    t6 = bodyCopy ? <RichTextCondensed richText={bodyCopy} as="body-tablet" className="text-text-secondary" /> : null;
    $[10] = bodyCopy;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex flex-col gap-4 tablet:gap-6">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== item.action) {
    t8 = item.action && item.action.to && <ActionLink actionTo={item.action.to} className="typography-component-sm-medium text-text-primary underline underline-offset-4">{getI18nString(item.action.text, "Learn More")}</ActionLink>;
    $[15] = item.action;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex flex-col items-center gap-6 tablet:gap-12">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t9) {
    t10 = <div className="flex flex-col items-center gap-6 tablet:gap-10">{t4}{t9}</div>;
    $[20] = t4;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}